import css from 'styled-jsx/css';

export default css`.login-container {
    .qrcode-status {
        .qrcode-status-0 {
            text-align: center;
            .qrcode-img {
                display: flex;
                justify-content: center;
                align-items: center;
                &-container {
                    padding: 6px;
                    box-sizing: border-box;
                    border-radius: 4px;
                    border: 1px solid rgba(216, 216, 216, 0.3);
                    :global(img) {
                        width: 100%;
                        height: 100%;
                    }
                    :global(.expire) {
                        width: 100%;
                        height: 100%;
                        background: rgba(0, 0, 0, 0.65);
                        display: flex;
                        align-items: center;
                        flex-direction: column;
                        justify-content: center;
                    }
                    :global(.expire .row-text) {
                        height: 20px!important;
                        font-size: 14px!important;
                        font-weight: 400!important;
                        color: #fff!important;
                        line-height: 20px!important;
                        padding: 0!important;
                    }
                    :global(.expire .row-btn a) {
                        margin: 0 auto;;
                        margin-top: 8px;
                        width: 68px!important;
                        height: 24px!important;
                        background: #FF6400;
                        border-radius: 60px;
                        display: inline-block;
                        font-size: 12px!important;
                        font-weight: 400;
                        color: #FFFFFF!important;
                        line-height: 24px!important;
                        cursor: pointer;
                    }
                }
            }
            .qrcode-text {
                div {
                    height: 20px;
                    font-weight: 400;
                    color: #000000;
                    line-height: 20px;
                    span {
                        color: #FF6400;
                    }
                }
            }
        }
        .qrcode-status-1 {
            .qrcode-success {
                border-radius: 4px;
                border: 1px solid rgba(216, 216, 216, 0.3);
                font-size: 0;
                display: flex;
                align-items: center;
                flex-direction: column;
                justify-content: center;
                div {
                    font-weight: 400;
                    color: #000000;
                }
            }
            .qrcode-success-tips {
                height: 22px;
                font-size: 14px;
                font-weight: 400;
                color: #666666;
                line-height: 22px;
                text-align: center;
            }
        }
    }
}

// 弹窗
.login-container-modal {
    .qrcode-status-0 {
        padding-top: 16px;
        .qrcode-img {
            &-container {
                width: 130px;
                height: 130px;
                margin-right: 24px;
            }
            &-guide {
                width: 110px;
                height: 198px;
            }
        }
        .qrcode-text {
            margin-top: 32px;
            div {
                font-size: 14px;
                margin-bottom: 8px;
            }
        }
    }
    .qrcode-status-1 {
        .qrcode-success {
            margin: 0 auto;
            width: 130px;
            height: 130px;
            margin-top: 51px;
            :global(svg) {
                width: 42px;
                height: 42px;
            }
            div {
                height: 20px;
                font-size: 14px;
                line-height: 20px;
                margin-top: 8px;
            }
        }
        .qrcode-success-tips {
            margin-top: 58px;
        }
    }
}

// 内嵌登录
.login-container-component {
    .qrcode-status-0 {
        padding-top: 8px;
        .qrcode-img {
            &-container {
                width: 120px;
                height: 120px;
                margin-right: 16px;
            }
            &-guide {
                width: 80px;
                height: 143px;
            }
        }
        .qrcode-text {
            margin-top: 5px;
            div {
                font-size: 12px;
                margin-bottom: 2px;
            }
        }
    }
    .qrcode-status-1 {
        .qrcode-success {
            margin: 0 auto;
            margin-top: 20px;
            width: 120px;
            height: 120px;
            :global(svg) {
                width: 26px;
                height: 26px;
            }
            div {
                margin-top: 7px;
                font-size: 12px;
                height: 17px;
                line-height: 17px;
            }
        }
        .qrcode-success-tips {
            margin-top: 20px;
        }
    }
}
`